import React from 'react';
import {Icon} from 'antd';

import InstructionLayout from '../instruction-layout';


const supportRequestItems = [
    'Опишите проблему и укажите, какое действие не получается выполнить.',
    'Укажите ИНН компании, с данными которой возникла проблема.',
    'Если вопрос связан с документом, приложите его к письму или добавьте ссылку на файл в облачном хранилище.',
    'Если необходимо скорректировать данные на сайте, приложите документы, подтверждающие основание для изменения.',
];


export default function Support() {
    return (
        <InstructionLayout title="Техническая поддержка">
            <p className="instruction-intro">
                Если при работе с платформой возник вопрос или техническая
                проблема, напишите специалистам службы поддержки.
            </p>

            <div className="support-contact">
                <span className="support-contact__icon">
                    <Icon type="mail"/>
                </span>

                <div className="support-contact__content">
                    <strong className="support-contact__title">
                        Электронная почта
                    </strong>

                    <a
                        className="support-contact__email"
                        href="mailto:support@svetofore.ru"
                    >
                        support@svetofore.ru
                    </a>
                </div>

                <a
                    className="support-contact__button"
                    href="mailto:support@svetofore.ru"
                >
                    Написать в поддержку
                </a>
            </div>

            <section className="service-section">
                <h2 className="service-section__title">
                    Что указать в обращении
                </h2>

                <p className="service-section__description">
                    Чем подробнее описана ситуация, тем быстрее специалисты
                    смогут разобраться в вопросе.
                </p>

                <div className="service-checklist">
                    {supportRequestItems.map((item, index) => (
                        <div
                            className="service-checklist__item"
                            key={item}
                        >
                            <span className="service-checklist__number">
                                {index + 1}
                            </span>

                            <p className="service-checklist__text">
                                {item}
                            </p>
                        </div>
                    ))}
                </div>
            </section>

            <div className="service-note">
                <Icon
                    className="service-note__icon"
                    type="info-circle"
                />

                <p className="service-note__text">
                    Указывать все пункты необязательно, однако полная
                    информация существенно ускорит решение вопроса.
                </p>
            </div>
        </InstructionLayout>
    );
}